import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import pb from '../lib/pocketbase';

const AdminRoute = () => {
    const user = pb.authStore.model;

    // Check if user is logged in and has admin role
    // Note: You must add a 'role' text field to your 'users' collection in PocketBase
    // and set it to 'admin' for your admin user.
    if (!user || user.role !== 'admin') {
        return <Navigate to="/connexion" replace />;
    }

    return <Outlet />;
};

export default AdminRoute;
